// extracted by mini-css-extract-plugin
export default {"wrapper-article":"FollowerInfo_wrapper-article__zdjzG","followers":"FollowerInfo_followers__8VdMy","login_name":"FollowerInfo_login_name__Iwvq5"};